export default __webpack_public_path__ + "static/media/step.fdbe5eb4.svg";